import {Breakpoints} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import {
    CARD_BORDER_COLOR,
    CARD_EMPHASIS_BACKGROUND,
    CARD_SHADOW_DEFAULT,
} from './cardStyleTokens'

export const StepContainerBorder = styled.div`
    border: ${({theme}) => theme.size.border.active} solid ${CARD_BORDER_COLOR};
    border-radius: ${({theme}) => theme.size.borderRadius.card};
    background: ${CARD_EMPHASIS_BACKGROUND};
    box-shadow: ${CARD_SHADOW_DEFAULT};
    position: relative;
    padding: ${({theme}) => theme.size.static450}
        ${({theme}) => theme.size.static350};
    margin: ${(props) => props.theme.size.static450}
        ${(props) => props.theme.size.grid002};
    transition: margin-top 0.5s cubic-bezier(0.645, 0.045, 0.355, 1),
        margin-bottom 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);

    @media (min-width: ${Breakpoints.b960}px) {
        padding: ${({theme}) => theme.size.static500}
            ${({theme}) => theme.size.static550}
            ${({theme}) => theme.size.static450};
        margin-left: ${(props) => props.theme.size.grid003};
        margin-right: ${(props) => props.theme.size.grid003};
    }

    @media (min-width: ${Breakpoints.b1280}px) {
        padding: ${({theme}) => theme.size.static500}
            ${({theme}) => theme.size.static450}
            ${({theme}) => theme.size.static450};
        margin-left: ${(props) => props.theme.size.grid004};
        margin-right: ${(props) => props.theme.size.grid004};
    }

    &.preview {
        margin: 0;
        padding: 0;
        border: 0;
        border-radius: ${({theme}) => theme.size.borderRadius.none};
        background: transparent;
        box-shadow: none;
        border-bottom: ${({theme}) => theme.size.border.default} solid
            ${CARD_BORDER_COLOR};

        &:first-child {
            border-top: ${({theme}) => theme.size.border.default} solid
                ${CARD_BORDER_COLOR};
        }
    }

    &.hidden {
        opacity: 0;
        height: 0;
        max-height: 0;
        overflow: hidden;
        background: transparent;
        box-shadow: none;
        padding: 0;
        margin: 0;
    }
`
